import { useEffect } from 'react'
import { useReselector } from '@/utils/sharedHooks'
import { useAnalyticsView } from '@/features/amplitude'
import { TypographyStyles } from '@/styles'

import { Text } from '@/ui'
import { selectUserStatements } from '@/features/user/your-practice/documents/lib/userDocuments.selector'
import { EditableStatementTable } from '../EditableStatementTable'

export const ReviewStatements = () => {
  const statements = useReselector(selectUserStatements)
  const pageView = useAnalyticsView()
  const currentYear = new Date().getFullYear()

  useEffect(() => {
    pageView('review monthly bank statements')
  }, [pageView])

  return (
    <div className="space-y-6">
      <Text variant={TypographyStyles.H2}>Review bank statements</Text>

      <div className="space-y-2">
        <Text>Double-check that you have uploaded bank statements for:</Text>
        <ul className="list-disc pl-5 space-y-1">
          <li>
            <Text>Each month of {currentYear}</Text>
          </li>
          <li>
            <Text>From all connected business accounts</Text>
          </li>
        </ul>
      </div>

      {statements.length > 0 && (
        <EditableStatementTable documents={statements} editable={false} />
      )}
    </div>
  )
}
